import type {ApiWorkforceProfileRecord} from '../WorkforceProfiles/workforceProfileApiTypes';

import {ApiSerializer} from '../../../../../serializers/ApiSerializer';


export const asApiWorkforceProfileRecord = (entry: unknown): ApiWorkforceProfileRecord =>
  (entry && typeof entry === 'object' ? ApiSerializer.toCamelCase(entry) : entry) as ApiWorkforceProfileRecord;
